import React from 'react';
import { ServicePageLayout } from '../../components/feature/service-page/ServicePageLayout';

const SamsungServicePage: React.FC = () => {
  return (
    <ServicePageLayout
      seo={{
        title: "Samsung Repair Kochi - Galaxy Service Center Kerala | Device Doctor Experts",
        description: "Professional Samsung Galaxy repair services in Kochi, Kerala. Expert Samsung device repair for Galaxy S24, S23, Note series, A series. Screen replacement, battery repair, water damage restoration with genuine parts.",
        keywords: "samsung repair kochi, galaxy service center kerala, samsung screen repair, samsung battery replacement, galaxy repair vyttila, samsung water damage repair",
        structuredData: { "@context": "https://schema.org", "@type": "Service", "name": "Samsung Galaxy Repair Services", "brand": { "@type": "Brand", "name": "Samsung" } }
      }}
      hero={{
        title: "Samsung Service Centre in Kochi",
        subtitle: "The go-to destination for fast, professional Samsung mobile phone repairs. With genuine parts, certified technicians and service options throughout the Kochi region, you're in safe hands.",
        stats: [{ value: '800+', label: 'Samsung Repairs' }, { value: '4.9★', label: 'Customer Rating' }, { value: 'Same Day', label: 'Service Available' }],
        backgroundImage: "/assets/samsung-hero-bg.jpg"
      }}
      serviceList={{
        introParagraph: "Below are the major service categories — each one handled with professional care.",
        services: [
          { id: 'display', title: 'Display Repairs', icon: 'ri-smartphone-line', image: '/assets/android-repair-new.jpg', description: 'Complete display repair solutions for all Samsung Galaxy models.', subServices: [{ title: 'Screen Repairs', description: 'Solutions for shattered glass, touch issues, and liquid damage.', features: ['Screen replacement', 'Ghost-touch correction', 'Pixel burn-in removal', 'Flickering screen fix'] }] }
        ]
      }}
      features={{
        title: "Why Choose Us",
        subtitle: "Experience the difference with Device Doctor's professional Samsung repair services in Kochi.",
        badgeText: "Why Choose Device Doctor",
        items: [
          { icon: 'ri-award-line', title: 'Certified Samsung Technicians', description: 'Certified Samsung-brand technicians with years of experience handling all Galaxy models.' },
          { icon: 'ri-shield-check-line', title: 'Genuine Brand Parts Only', description: 'Genuine brand-approved spare parts only — no compromises on quality.' },
          { icon: 'ri-time-line', title: 'Same-Day Service', description: 'Same-day turnaround for most common models to get you back online quickly.' },
          { icon: 'ri-search-line', title: 'Free Diagnostics', description: 'Free diagnostics, transparent pricing & 1-month repair warranty on all Samsung repairs.' },
          { icon: 'ri-truck-line', title: 'All-Kerala Courier Services', description: 'Convenient courier services available across all Kerala districts.' },
          { icon: 'ri-map-pin-line', title: 'Convenient Location', description: 'Convenient location in Vyttila, Kochi + free pickup & delivery across the city.' }
        ]
      }}
      models={{
        title: "Models We Service",
        subtitle: "We cover all Samsung Galaxy models, including the latest and legacy devices.",
        categories: [
          { title: 'Galaxy S Series', icon: 'ri-smartphone-line', models: ['Galaxy S6 → S24 series', 'Galaxy S21 FE'], color: 'bg-blue-500' },
          { title: 'Galaxy Note Series', icon: 'ri-edit-line', models: ['Galaxy Note 8 → Note 20 series'], color: 'bg-purple-500' },
          { title: 'Galaxy A Series', icon: 'ri-phone-line', models: ['Galaxy A50 → A72'], color: 'bg-green-500' }
        ]
      }}
      testimonials={{
        items: [
          { name: 'Rahul', location: 'Vyttila, Kochi', rating: 5, text: 'My Galaxy S21 had a cracked screen and they fixed it same-day. Super friendly team, genuine parts and no hidden cost.', device: 'Galaxy S21' },
          { name: 'Anjana', location: 'Edappally, Kochi', rating: 5, text: 'Battery was draining fast on my Galaxy A52, they replaced it quickly and it works like new.', device: 'Galaxy A52' }
        ]
      }}
      faq={{
        items: [
          { question: 'How long will the repair take?', answer: 'Most screen and battery repairs are done same-day if booked early. Other complex hardware work may take 1-2 days.' },
          { question: 'Do you use genuine Samsung parts?', answer: 'Yes — we only use brand-approved components and adhere to Samsung repair standards.' },
          { question: 'Is there a warranty on repairs?', answer: 'Yes, all our Samsung repairs come with a comprehensive 1-month warranty.' }
        ]
      }}
      cta={{
        title: "Ready to get your Samsung fixed?",
        subtitle: "Contact Device Doctor – Best Samsung Service Centre in Kochi. Call now or book online for same-day service and All-Kerala Courier Services.",
        themeColor: "blue"
      }}
    />
  );
};

export default SamsungServicePage;
export { SamsungServicePage };